module.exports = __webpack_public_path__ + "static/img/rse.d3ba5e5c.png";